import { render, staticRenderFns } from "./faces.vue?vue&type=template&id=c682fc62&scoped=true&"
import script from "./faces.vue?vue&type=script&lang=js&"
export * from "./faces.vue?vue&type=script&lang=js&"
import style0 from "./faces.vue?vue&type=style&index=0&id=c682fc62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c682fc62",
  null
  
)

export default component.exports